import React from 'react';
import { useSession } from '../SessionContext';
import SessionBlocker from '../../components/SessionBlocker';

export const SessionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { showExpiredPopup, sessionLoading } = useSession();

  if (sessionLoading) return null;

  if (showExpiredPopup) {
    return <SessionBlocker />;
  }

  return <>{children}</>;
};
